import * as XLSX from "xlsx";

const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
const fullMonths = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
const monthNumber = text => months.findIndex((month, index) => text.toLowerCase() === month || text.toLowerCase() === fullMonths[index] || (month === "sep" && text.toLowerCase() === "sept")) + 1;
const calendar = (year, month, day) => {
  if (year < 1 || year > 9999 || month < 1 || month > 12 || day < 1) return null;
  const date = new Date(0);
  date.setFullYear(year, month - 1, day);
  date.setHours(0, 0, 0, 0);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
};
function parseImportDate(value, { date1904 = false, dateOrder = "" } = {}) {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : calendar(value.getFullYear(), value.getMonth() + 1, value.getDate());
  const text = typeof value === "string" ? value.trim() : value;
  // Unformatted numeric Excel dates are serial days, never Unix milliseconds.
  if (typeof text === "number" || (typeof text === "string" && /^\d{5}(?:\.\d+)?$/.test(text))) {
    const serial = Number(text);
    if (!Number.isFinite(serial) || serial < 1 || serial >= 2958466) return null;
    const parts = XLSX.SSF.parse_date_code(serial, {date1904});
    return parts ? calendar(parts.y, parts.m, parts.d) : null;
  }
  if (typeof text !== "string") return null;
  let parts = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?$)/.exec(text);
  if (parts) return calendar(Number(parts[1]), Number(parts[2]), Number(parts[3]));
  parts = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/.exec(text);
  if (parts) {
    const first = Number(parts[1]), second = Number(parts[2]);
    if (!dateOrder && first <= 12 && second <= 12 && first !== second) return null;
    const dayFirst = dateOrder === "DMY" || (!dateOrder && first > 12);
    return calendar(Number(parts[3]), dayFirst ? second : first, dayFirst ? first : second);
  }
  // Validate named-month formats explicitly; Date.parse silently rolls invalid days forward.
  parts = /^([A-Za-z]+)\.?[-\s]+(\d{1,2})(?:,\s*|[-\s]+)(\d{4})$/.exec(text);
  if (parts) return calendar(Number(parts[3]), monthNumber(parts[1]), Number(parts[2]));
  parts = /^(\d{1,2})[-\s]+([A-Za-z]+)\.?(?:,\s*|[-\s]+)(\d{4})$/.exec(text);
  return parts ? calendar(Number(parts[3]), monthNumber(parts[2]), Number(parts[1])) : null;
}
export function normalizeImportDate(value, options) {
  const date = parseImportDate(value, options);
  return date ? `${String(date.getFullYear()).padStart(4, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : null;
}
export const isValidImportDate = (value, options) => normalizeImportDate(value, options) !== null;
export function formatImportDate(value, options) {
  if (value === "" || value === null || value === undefined) return "—";
  const date = parseImportDate(value, options);
  return date ? date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : String(value);
}
export function importDateInput(value, options) {
  if (value === "" || value === null || value === undefined) return "";
  return normalizeImportDate(value, options) || String(value).slice(0, 10);
}
